import classNames from 'classnames'
import PropTypes from 'prop-types'

import Card from 'components/card'
import { InfoButton } from 'components/buttons'
import { AddAnyStoreIcon } from 'components/icons'
import { mobileAppDownloadPath } from 'lib/urls'

import css from './feed-items.scss'

export const AppPromoTile = () => (
  <a href={mobileAppDownloadPath()}>
    <Card className={classNames(css.appPromoTile, 'ptxl prxl pbxl plxl')}>
      <AddAnyStoreIcon className={classNames(css.appPromoTileIcon, 'mbl')} />
      <p className="mbl">Ready to add any item from any store?</p>
      <InfoButton pill>Get the Babylist App</InfoButton>
    </Card>
  </a>
)
